<template>
  <p-dialog
    class="p-dialog-notify"
    :title="title"
    :type="type"
    :has-close-button="hasCloseButton"
    v-on="$listeners"
    @close="close()"
    @closeOnEsc="close()"
  >
    <template #content>
      <p>{{ message }}</p>
    </template>
  </p-dialog>
</template>

<script lang="ts">
  import Vue from 'vue';

  export default Vue.extend({
    props: {
      title: { type: String, default: undefined },
      message: { type: String, default: undefined },
      type: { type: String, default: 'info' },

      hasCloseButton: { type: Boolean, default: true },
    },
    methods: {
      close() {
        this.$emit('input');
      },
    },
  });
</script>
